import service from "@/plugins/request";

export function apiTjeqList() {
  return service({
    url: "/v1/entry/tj-eq-list",
    method: "get"
  });
}

// 获取天花板保存的数据
export function apiGetLineUpInfo(params) {
  return service({
    url: "/v1/protected/contentLineup/info",
    method: "get",
    params
  });
}

// 获取天花板保存的数据
export function apiSaveLineUpInfo(params) {
  return service({
    url: "/v1/protected/contentLineup/save",
    method: "post",
    data: params
  });
}
